import { Grid } from "@mui/material";
import React from "react";
import AnalyticCard from "./AnalyticCard";
import { Analytics } from "../../types/analytics";

const calculatePercentage = (array: any[]) => {
  if (!array) return 0;
  if (array.length <= 1) return 0;
  const currentTotal = array[array.length - 1].total;
  const previousTotal = array[array.length - 2].total;
  const percentageChange =
    ((currentTotal - previousTotal) / previousTotal) * 100;
  return percentageChange;
};

const CARD_ACCENTS = ["#0F172A", "#059669", "#EAB308", "#0EA5E9"];

function AnalyticCards({
  analytics,
  cardsData,
  period,
  allowedResources,
}: {
  analytics: Analytics;
  cardsData: any;
  period: any;
  allowedResources: any[];
}) {
  let colorIndex = 0;
  const nextColor = () => CARD_ACCENTS[colorIndex++ % CARD_ACCENTS.length];

  return (
    <Grid
      columns={{ xs: 1, md: 3 }}
      container
      direction="row"
      justifyContent="flex-start"
      spacing={2}
      sx={{ flexWrap: { xs: "wrap", md: "wrap", lg: "nowrap" } }}>
      {allowedResources.includes("students") && (
        <Grid item xs={12} md={4}>
          <AnalyticCard
            accentColor={nextColor()}
            title="Total Students"
            value={analytics?.students?.count}
            comment=""
            percentage={calculatePercentage(cardsData?.students[period]?.stats as any)}
          />
        </Grid>
      )}
      {allowedResources.includes("submissions") && (
        <Grid item xs={12} md={4}>
          <AnalyticCard
            accentColor={nextColor()}
            title="Total Submissions"
            value={analytics?.submissions?.count}
            comment=""
            percentage={calculatePercentage(cardsData.submissions[period]?.stats as any)}
          />
        </Grid>
      )}
      {allowedResources.includes("transactions") && (
        <Grid item xs={12} md={4}>
          <AnalyticCard
            accentColor={nextColor()}
            title="Total Transactions"
            value={analytics?.transactions?.count}
            comment=""
            prefix="RM"
            isCurrency
            percentage={calculatePercentage(cardsData?.transactions[period]?.stats as any)}
          />
        </Grid>
      )}
      {allowedResources.includes("tasks") && (
        <Grid item xs={12} md={4}>
          <AnalyticCard
            accentColor={nextColor()}
            title="Completed Tasks"
            value={analytics?.tasks?.count}
            comment=""
            percentage={calculatePercentage(cardsData?.tasks[period]?.stats as any)}
          />
        </Grid>
      )}
    </Grid>
  );
}

export default AnalyticCards;
